import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FeaturesProvider } from './contexts/FeaturesContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import Security from './pages/Security';
import ActivityLog from './pages/ActivityLog';
import Settings from './pages/Settings';
import AdminPanel from './pages/AdminPanel';
import Payroll from './pages/Payroll';
import Approvals from './pages/Approvals';
import Layout from './pages/Layout';
import Finance from './pages/Finance';
import TaxConfiguration from './pages/TaxConfiguration';
import Documents from './pages/Documents';
import Contracts from './pages/Contracts';
import MyProfile from './pages/MyProfile';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import Benefits from './pages/Benefits';
import Clients from './pages/Clients';
import Shifts from './pages/shifts/Shifts';
import Deductions from './pages/Deductions';
import OvertimeConfiguration from './pages/OvertimeConfiguration';  // ← AGREGAR
import OvertimeTaxConfiguration from './pages/OvertimeTaxConfiguration';
import PublicHolidays from './pages/PublicHolidays';
import PayrollConsolidation from './pages/PayrollConsolidation';
import Toaster from './components/Toaster';
import TimeAttendance from './pages/timeAttendance/TimeAttendance';
import { AttendanceRedirect, TimeManagementRedirect } from './pages/timeAttendance/legacyRedirects';
import PortalApp from './pages/portal/PortalApp';
import PortalShifts from './pages/portal/PortalShifts';
import PortalAttendance from './pages/portal/PortalAttendance';
import PortalPayslips from './pages/portal/PortalPayslips';
import PortalLeave from './pages/portal/PortalLeave';
import PortalMe from './pages/portal/PortalMe';
function App() {
  return (
    <LanguageProvider>
    {/* notify() shows toasts instead of alert() while this is mounted */}
    <Toaster />
    <AuthProvider>
    <FeaturesProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes with Layout */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Layout><Dashboard /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <Layout><AdminPanel /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/employees" 
            element={
              <ProtectedRoute>
                <Layout><Employees /></Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* The old pages redirect to Time & Attendance for a while (their
              files stay until these routes go). */}
          <Route path="/attendance" element={<AttendanceRedirect />} />
          
          <Route
            path="/time-attendance"
            element={
              <ProtectedRoute>
                <Layout><TimeAttendance /></Layout>
              </ProtectedRoute>
            }
          />

          <Route path="/time-management" element={<TimeManagementRedirect />} />
          
          <Route 
            path="/payroll" 
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'finance_manager', 'operations_manager']}>
                <Layout><Payroll /></Layout>
              </ProtectedRoute>
            } 
          />
          {/* ⭐ AGREGAR ESTA RUTA AQUÍ */}
          <Route 
  path="/consolidations" 
  element={
    <ProtectedRoute allowedRoles={['super_admin', 'finance_manager', 'operations_manager']}>
      <Layout><PayrollConsolidation /></Layout>
    </ProtectedRoute>
  } 
/>

          {/* ⭐ AGREGAR ESTA RUTA AQUÍ */}
          {/* Clients and their sites; the API checks the clients permission */}
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Layout><Clients /></Layout>
              </ProtectedRoute>
            }
          />
          {/* The shift planner; the API checks the schedules permission */}
          <Route
            path="/shifts"
            element={
              <ProtectedRoute>
                <Layout><Shifts /></Layout>
              </ProtectedRoute>
            }
          />

          <Route 
            path="/benefits"  
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'hr_manager', 'finance_manager']}>
                <Layout><Benefits /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/approvals" 
            element={
              <ProtectedRoute>
                <Layout><Approvals /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/finance" 
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'finance_manager']}>
                <Layout><Finance /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/tax-configuration" 
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'finance_manager', 'hr_manager']}>
                <Layout><TaxConfiguration /></Layout>
              </ProtectedRoute>
            } 
          />
            <Route 
     path="/overtime-tax-configuration" 
     element={
       <ProtectedRoute allowedRoles={['super_admin', 'finance_manager', 'hr_manager']}>
         <Layout><OvertimeTaxConfiguration /></Layout>
       </ProtectedRoute>
     } 
   />
          <Route 
                path="/overtime-configuration" 
                element={
                  <ProtectedRoute allowedRoles={['super_admin', 'hr_manager', 'operations_manager']}>
                    <Layout><OvertimeConfiguration /></Layout>
                  </ProtectedRoute>
                } 
              />
                                      <Route 
                path="/deductions" 
                element={
                  <ProtectedRoute allowedRoles={['super_admin', 'hr_manager', 'finance_manager']}>
                    <Layout><Deductions /></Layout>
                  </ProtectedRoute>
                } 
              />
                        
          <Route 
            path="/reports" 
            element={
              <ProtectedRoute>
                <Layout><Reports /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Layout><Profile /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/security" 
            element={
              <ProtectedRoute>
                <Layout><Security /></Layout>
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/activity" 
            element={
              <ProtectedRoute>
                <Layout><ActivityLog /></Layout>
              </ProtectedRoute>
            } 
          />

                  <Route 
                path="/documents" 
                element={
                  <ProtectedRoute allowedRoles={['super_admin', 'hr_manager', 'finance_manager']}>
                    <Layout><Documents /></Layout>
                  </ProtectedRoute>
                } 
              />

              <Route 
                path="/contracts" 
                element={
                  <ProtectedRoute allowedRoles={['super_admin', 'hr_manager', 'finance_manager']}>
                    <Layout><Contracts /></Layout>
                  </ProtectedRoute>
                } 
              />
              {/* Managed by the roles its backend lets write (publicHolidayRoutes). */}
              <Route
                path="/public-holidays"
                element={
                  <ProtectedRoute allowedRoles={['super_admin', 'hr_manager']}>
                    <Layout><PublicHolidays /></Layout>
                  </ProtectedRoute>
                }
              />
          
          <Route 
            path="/settings" 
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <Layout><Settings /></Layout>
              </ProtectedRoute>
            } 
          />
          <Route path="/my-profile" element={<MyProfile />} />
          
          {/* The guard portal: role employee only, its own frame, no management menu */}
          <Route
            path="/portal"
            element={
              <ProtectedRoute allowedRoles={['employee']}>
                <PortalApp />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="shifts" replace />} />
            <Route path="shifts" element={<PortalShifts />} />
            <Route path="attendance" element={<PortalAttendance />} />
            <Route path="payslips" element={<PortalPayslips />} />
            <Route path="leave" element={<PortalLeave />} />
            <Route path="me" element={<PortalMe />} />
            <Route path="*" element={<Navigate to="shifts" replace />} />
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
        
      </Router>
    </FeaturesProvider>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;